<template>
  <div>
    <div class="sub">
      <div class="oLeft">
 <el-button type="primary" @click="fanhui()">返回</el-button>
 <el-button type="primary" @click="print()">打印</el-button>
<el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="date"
        label="日期"
        width="180">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="address"
        label="地址">
      </el-table-column>
    </el-table>
			</div>

    </div>
  </div>
</template>

<script>
// const ipcRender = window.require("electron").ipcRenderer;

export default {
  name: "HelloWorld",
  data() {
    return {
			 tableData: [{
			            date: '2016-05-02',
			            name: '王小虎',
			            address: '上海市普陀区金沙江路 1518 弄'
			          }, {
			            date: '2016-05-04',
			            name: '王小虎',
			            address: '上海市普陀区金沙江路 1517 弄'
			          }, {
			            date: '2016-05-01',
			            name: '王小虎',
			            address: '上海市普陀区金沙江路 1519 弄'
			          }, {
			            date: '2016-05-03',
			            name: '王小虎',
			            address: '上海市普陀区金沙江路 1516 弄'
			          }],
      isShow:false,
      info: {
        coupon:0,
        discount:10,
        orderData: [],
        priceInfo:{},
         preferential:0

      },

    };
  },
  mounted() {
     this.print();
  },
	methods: {

		print() {
				window.Android.printWebViewContent(1,2)
		},
		 


	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
.sub {
  width: 100%;
  height: 100vh;
  /* background: red; */
  display: flex;
}
.oLeft {
  flex: 1;
  height: 100vh;
  /* background: yellow; */
}
.oRight {
  width: 492px;
  height: 100vh;
  background: #fff;
  .list {
    width: 100%;
    height: calc(100vh - 153px);
  }
  .discounts {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .discountsAll {
      span {
        display: inline-block;
        background: rgba(0, 191, 138, 0.08);
        color: @desk-font-color;
        font-size: 16px;
        padding: 8px;
        border-radius: 4px;
        border: 1px solid #bceee0;
      }
    }
    .discountsPrice {
      color: rgb(0, 191, 138);
      font-size: 16px;
      line-height: 100%;
    }
  }
  .price {
    width: calc(100% - 24px);
    margin: 0 auto;
    height: 70px;
     border-radius: 4px;
    background: @desk-color;
    position: relative;
    display: flex;
    align-items: center;
    color: #fff;
    i{
      font-style:normal;
      text-decoration:line-through;
    }
  }
  .price::after {
    content: "";
    width:100%;
    height: 4px;
    background: #00b181;
    position: absolute;
    bottom: 0;
    left: 0;
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hi.vue